import { Link } from 'react-router-dom';

export const Footer = () => {
  const services = [
    { name: 'Trademark Registration (UK)', path: '/services/trademark-registration' },
    { name: 'Copyright Registration', path: '/services/copyright-registration' },
    { name: 'Trademark Comprehensive Search', path: '/services/comprehensive-search' },
    { name: 'Company Formation', path: '/services/company-formation' },
    { name: 'Amazon Brand Registry', path: '/services/amazon-brand-registry' }
  ];

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img 
                src="/assets/img/brand/logo-light.png" 
                alt="Trademark Assist Logo" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-primary-foreground/80 text-sm leading-relaxed">
              Professional trademark registration services in the United Kingdom. Protect your brand with confidence.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.path}>
                  <Link to={service.path} className="text-primary-foreground/80 hover:text-primary-foreground text-sm transition-colors">
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-primary-foreground/80 hover:text-primary-foreground text-sm transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3 text-primary-foreground/80 text-sm">
              <li className="flex items-start gap-2">
                <span className="mt-1">📍</span>
                <span>20 St Thomas St, London SE1 9RS, United Kingdom</span>
              </li>
              <li className="flex items-center gap-2">
                <span>📧</span>
                <span>info@trademarkassist.co.uk</span>
              </li>
              <li className="flex items-center gap-2">
                <span>📞</span>
                <span>+44 20 1234 5678</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-primary-foreground/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-primary-foreground/80 text-sm">
              © 2026 Trademark Assist. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm">
              <Link to="/privacy-policy" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                Privacy Policy
              </Link>
              <span className="text-primary-foreground/40">|</span>
              <Link to="/terms" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
